import { FAB_SURGE_GET_USER_ROLE, FAB_SURGE_GET_USER_ROLE_SUCCESS, FAB_SURGE_GET_USER_ROLE_ERROR, FAB_SURGE_GET_USER_ROLE_EMPTY } from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetFabUserRole = (state = initialState, action) => {
  switch (action.type) {
    case FAB_SURGE_GET_USER_ROLE:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case FAB_SURGE_GET_USER_ROLE_SUCCESS:
      console.log('hello action', action.payload);
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case FAB_SURGE_GET_USER_ROLE_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case FAB_SURGE_GET_USER_ROLE_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetFabUserRole;
